import React, { useEffect, useState } from 'react';
import { ListGroup } from 'react-bootstrap';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';
import PIKLOGO from '../../../../../assets/images/Pikture Final Logo.png';
import CLUBWORLD from '../../../../../assets/images/ClubWorld_trans.png';

const NavGroup = ({ layout, group, memberD }) => {
  const [member, setMember] = useState({
    name: '',
    type: ''
  });
  const [membertype, setMemType] = useState('');
  const { name, type } = member;
  const [filterData, setFilterData] = useState([]);
  useEffect(() => {
    const memberData = JSON.parse(localStorage.getItem('memberData'));
    const memType = localStorage.getItem('usertype');

    setMemType(memType);
    if (memberData !== null && Object.keys(memberData).length > 0) {
      setMember((prev) => ({
        ...prev,
        name: memberData[0].membername,
        type: memberData[0].membertype
      }));
    }
  }, [layout, group, memberD]);

  useEffect(() => {
    let usertype = localStorage.getItem('usertype');
    let config = JSON.parse(localStorage.getItem('config'));
    if (usertype === 'Member') {
      const activeFeatures = config
        ?.filter((item) => item.activeStatus === 'Active')
        .map((item) => item.featureName?.replace(/\s+/g, '')?.toLowerCase());

      const filteredMenuItems = group?.children?.filter(
        (item) =>
          activeFeatures?.includes(item.title?.replace(/\s+/g, '')?.toLowerCase()) ||
          item.title === 'Gallery' ||
          item.title === 'Orders' ||
          item.title === 'Suggestion' || item.id === 'onlinpayment' || item.id === 'room' || item.id === 'feedback' || item.id === 'MyRooms'
      );
      setFilterData(filteredMenuItems);
    } else if (usertype === 'Admin') {
      var configs = JSON.parse(localStorage.getItem('config'));
      const filteredConfig = group?.children?.filter((item) => {
        const mandatoryIds = ['Cottages','staff', 'paymentlist', 'memberlist', 'ChangeRequest','EventReport', 'EventNotification','affiliatedlist', 'Gallery', 'Suggestion',"Digital"];
        if (mandatoryIds.includes(item.id)) {
          return true;
        }
        const feature = configs?.find((feature) => {
          // if (item?.title === 'Facility' && feature?.featureName === 'FacilityBooking' && feature?.activeStatus === 'Active') {
          //   return true;
          // }
          return feature?.featureName?.toLowerCase() === item.id?.toLowerCase() && feature?.activeStatus === 'Active';
        });

        return feature !== undefined;
      });
      setFilterData(filteredConfig);
    }
  }, [group]);

  let navItems = '';
  //console.log(group)
  if (filterData) {
    const groups = filterData;

    navItems = groups.map((item) => {
      const getType = JSON.parse(localStorage.getItem('loginData'));
      switch (item.type) {
        case 'collapse':
          return <NavCollapse key={item.id} collapse={item} type="main" />;
        case 'Admin':
          return <NavItem layout={layout} key={item.id} item={item} />;
        case 'Member':
          return <NavItem layout={layout} key={item.id} item={item} />;
        case 'club':
          return <NavItem layout={layout} key={item.id} item={item} />;
        default:
          return false;
      }
    });
  }

  return (
    <React.Fragment>
      {membertype === 'Member' && (
        <>
          <ListGroup.Item as="li" bsPrefix=" " className="nav-item pcoded-menu-caption border-change">
            <label className="text-capitalize" style={{ color: '#ff5858' }}>
              {member?.name}
            </label>
          </ListGroup.Item>
          <ListGroup.Item as="li" bsPrefix=" " className="nav-item pcoded-menu-caption border-change border-color">
            <label className="text-capitalize">{member?.type}</label>
          </ListGroup.Item>
        </>
      )}

      {navItems}

      <div className="position-abs text-capitalize">
        <p>
          Powered By
          <a href="https://clubworld.in/" target="blank">
            {' '}
            <img src={CLUBWORLD} alt="no image" />
          </a>
        </p>
      </div>
    </React.Fragment>
  );
};

export default NavGroup;
